import React, { Component } from "react";

export default (WrapperComponent) => {
  return class extends Component {
    componentDidMount() {
      window.scrollTo(0, 0);
    }

    render() {
      return <WrapperComponent {...this.props} />;
    }
  };
};



// WEBPACK FOOTER //
// ./src/components/decorateWindow.js